import React, { useEffect, useState } from "react"
import { toast } from "react-toastify"
import { useHistory } from "react-router-dom"
import { ENDPOINT } from "../../../constants"
import { useAuth } from "../../../contexts/AuthContext"
import { useSearchParams } from "../../../hooks/useQuerySearch"
import { FetchApi } from "../../../api/fetch"
import { removeTrailingSlash } from "../../../utils"

const TwitterBot = () => {
  const { getUserJWT } = useAuth()
  const { searchParams, get } = useSearchParams()
  const { push } = useHistory()

  const redirect_uri = removeTrailingSlash(
    window.location.origin + window.location.pathname
  )

  const [activating, setActivating] = useState(false)
  const [checking, setChecking] = useState(false)
  const [authenticating, setAuthenticating] = useState(false)
  const [status, setStatus] = useState({ is_running: false, is_auth: false })

  const activateTwitterBot = async () => {
    try {
      const userJWT = await getUserJWT()
      if (!userJWT) throw new Error("No token")
      setActivating(true)
      const data = await FetchApi({
        endpoint: ENDPOINT.ACTIVATE_TWITTER_BOT,
        JWT: userJWT,
        headers: {
          "Cache-Control": "no-cache",
        },
      })
      await checkTwitterBotStatus()
      toast.success(data.message)
    } catch (error) {
      toast.error((error as Error).message)
    } finally {
      setActivating(false)
    }
  }

  const checkTwitterBotStatus = async () => {
    try {
      const userJWT = await getUserJWT()
      if (!userJWT) throw new Error("No token")
      setChecking(true)
      const data = await FetchApi({
        endpoint: ENDPOINT.CHECK_TWITTER_BOT_STATUS,
        JWT: userJWT,
        headers: {
          "Cache-Control": "no-cache",
        },
      })

      setStatus(data.data)
    } catch (error) {
      toast.error((error as Error).message)
    } finally {
      setChecking(false)
    }
  }

  const goToAuthUrl = async () => {
    try {
      const userJWT = await getUserJWT()
      if (!userJWT) throw new Error("No token")
      setAuthenticating(true)
      const data = await FetchApi({
        endpoint: ENDPOINT.GET_TWITTER_AUTH_URL,
        method: "POST",
        JWT: userJWT,
        body: { redirect_uri },
        headers: {
          "Cache-Control": "no-cache",
        },
      })

      const url = data.data.auth_url

      if (url) {
        window.location.href = url
      }
    } catch (error) {
      toast.error((error as Error).message)
    }
  }
  const handleCode = async (code: string, state: string) => {
    try {
      setAuthenticating(true)

      const userJWT = await getUserJWT()
      if (!userJWT) throw new Error("No token")
      const data = await FetchApi({
        endpoint: ENDPOINT.TWITTER_BOT_CALLBACK,
        method: "POST",
        JWT: userJWT,
        body: { redirect_uri, code, state },
        headers: {
          "Cache-Control": "no-cache",
        },
      })

      if (data?.success) {
        toast.success("Twitter authenticated successfully")
        await checkTwitterBotStatus()
      } else {
        throw new Error(data?.message || "Twitter authentication failed")
      }
    } catch (error) {
      toast.error((error as Error).message)
    } finally {
      setAuthenticating(false)
    }
  }

  useEffect(() => {
    checkTwitterBotStatus()
  }, [])

  useEffect(() => {
    const code = get("code"),
      state = get("state")

    if (!code || !state) return

    handleCode(code, state)
    push(window.location.pathname)
  }, [searchParams, window.location.pathname])

  return (
    <div className="flex flex-col gap-5">
      <h1 className="font-medium text-2xl text-left">Twitter</h1>
      <p>
        Status:{" "}
        {checking ? "..." : status.is_running ? "Running" : "Not running"}
      </p>
      <p>
        Auth Status:{" "}
        {checking
          ? "..."
          : status.is_auth
          ? "Authenticated"
          : "Not authenticated"}{" "}
      </p>

      <div className="flex gap-5">
        <button
          onClick={checkTwitterBotStatus}
          className="w-fit p-[1px] bg-gradient text-white font-medium rounded-xl"
        >
          <span className="bg-kyzzen-primary block px-8 py-2 rounded-xl">
            {checking ? "Checking..." : "Refresh status"}
          </span>
        </button>
        {/* {!status.is_auth && ( */}
        <button
          onClick={goToAuthUrl}
          className="w-fit p-[1px] bg-gradient text-white font-medium rounded-xl"
        >
          <span className="bg-kyzzen-primary block px-8 py-2 rounded-xl">
            {authenticating ? "Authenticating..." : "Authenticate"}
          </span>
        </button>
        {/* )} */}
        {!status.is_running && (
          <button
            onClick={activateTwitterBot}
            className="w-fit p-[1px] bg-gradient text-white font-medium rounded-xl"
          >
            <span className="bg-kyzzen-primary block px-8 py-2 rounded-xl">
              {activating ? "Activating..." : "Activate Bot"}
            </span>
          </button>
        )}
      </div>
      <hr className="border border-gray-80 " />
    </div>
  )
}

export default TwitterBot
